/**
 * @file office-task.js
 * The Office Task modal CRUD
 *
 */

var officeTask = (function ($, Handlebars, ISN) {

    var _modalTemplate = '';
    var _filters = {};
    var _tasks = [];
    var _totalTaskCount = 0;

    function _loadModalTemplate(callback) {
        $.get('/' + ISN.settings.companykey + '/office-task/modal-template')
            .then(callback);
    }

    function _getModalTemplate(callback) {
        if ('' == _modalTemplate) {
            _loadModalTemplate(function (content) {
                _modalTemplate = content;
                callback(_modalTemplate);
            });
        } else {
            callback(_modalTemplate);
        }
    }

    function _compileTemplate(template, data) {
        var compiled;
        data = data || {};
        $.extend(data, { ISN: ISN });
        compiled = Handlebars.compile(template);
        return compiled(data);
    }

    function _renderTaskTable(box) {
        var template = $('<div>').html(_modalTemplate);
        var tbodyTemplate = template.find('#office-task-table-tbody-template');
        var compiled = _compileTemplate(tbodyTemplate.html(), { tasks: _tasks });
        box.find('#office-task-table').find('tbody').empty().off('*').append(compiled);

        box.find('#office-task-table').find('[data-message]').each(function () {
            var content;
            if (this.textContent.length > 250) {
                content = this.textContent.slice(0, 250);
                content += '<span data-hidden-content style="display: none;">';
                content += this.textContent.slice(250);
                content += '</span>&nbsp;&nbsp;&nbsp;';
                content += '<a href="javascript:;" style="font-size: 0.85em;" onclick="$(this).prev().show();$(this).next().show();$(this).hide();">-show full-</a>';
                content += '<a href="javascript:;" style="font-size: 0.85em; display: none;" onclick="$(this).prev().show();$(this).prev().prev().hide();$(this).hide();">-hide full-</a>';
                this.innerHTML = content;
            }
        });

        box.find('[data-edit-task-button]').on('click', function () {
            _editTask($(this).parents('[data-task-id]').data('task-id'), box);
        });

        box.find('[data-delete-task-button]').on('click', function () {
            if (confirm('Are you sure you  want to delete this task?')) {
                _deleteTask($(this).parents('[data-task-id]').data('task-id'))
                    .then(function () {
                        _loadAndRender(box);
                    });
            }
        });

        box.find('[data-complete-task-button]').on('click', function () {
            _setTaskComplete($(this).parents('[data-task-id]').data('task-id'));
            $(this).parents('[data-task-id]')
                .removeAttr('class')
                .addClass('success')
                .css({ 'opacity': 0.50 })
                .find('[data-due-today],[data-overdue]')
                .hide();
            $(this).parent().find('[data-incomplete-task-button]').show().on('click', function () {
                _setTaskNotComplete($(this).parents('[data-task-id]').data('task-id'))
                    .then(function () {
                        _loadAndRender(box);
                    })
            });
            $(this).hide();
        });
    }

    function _showLoading() {
        $('[data-loading]').show();
    }

    function _hideLoading() {
        $('[data-loading]').hide();
    }

    function _loadTasks(callback) {
        var filters = 'incomplete-only=1';
        if (_filters.hasOwnProperty('due') && _filters.due) {
            filters += '&due=' + _filters.due
        }
        if (_filters.hasOwnProperty('assigned') && _filters.assigned) {
            filters += '&assigned=' + _filters.assigned;
        }
        _showLoading();
        $.getJSON('/' + ISN.settings.companykey + '/office-task/recent?' + filters)
            .then(function (response) {
                _tasks = response.tasks;
                _totalTaskCount = response.total;
                _hideLoading();
                callback(_tasks);
            });
    }

    function _loadOrderDetails(oid, box) {
        box.find('[data-order-details-loading]').show();
        $.getJSON('/' + ISN.settings.companykey + '/order/json-details?oid=' + oid)
            .then(function (response) {
                _renderOrderDetails(response, box);
                box.find('[data-order-details-loading]').hide();
            });
    }

    function _getTaskDetails(id) {
        return $.getJSON('/' + ISN.settings.companykey + '/office-task/details?id=' + id);
    }

    function _setTaskComplete(id) {
        return $.post('/' + ISN.settings.companykey + '/office-task/complete?id=' + id);
    }

    function _setTaskNotComplete(id) {
        return $.post('/' + ISN.settings.companykey + '/office-task/not-complete?id=' + id);
    }
    
    function _saveTask(box) {
        var data = {
            id: box.find('[data-task-id]').val(),
            message: box.find('[data-task-message]').val(),
            assigned: box.find('[data-assigned]').val(),
            due: box.find('[data-due]').val(),
            dueTime: box.find('[data-due-time]').val(),
            oid: box.find('[data-order-search]').attr('data-oid'),
            remindEmail: box.find('[data-remind-email]').is(':checked'),
            remindSms: box.find('[data-remind-sms]').is(':checked'),
            remindMinutes: box.find('[data-remind-minutes]').val()
        };
        _disableTaskForm(box);
        box.find('[data-save-loading]').show();
        $.post('/' + ISN.settings.companykey + '/office-task/save', { json: JSON.stringify(data) }, function (response) {
                box.find('[data-save-loading]').hide();
                _enableTaskForm(box);
                if (response.status == 'ok') {
                    _hideAddTaskForm(box);
                    _resetTaskForm(box);
                    _loadAndRender(box);
                    box.find('[data-task-saved]').text(
                        'Task has been ' + (data.id != '' ? 'updated' : 'added') + '. Don\'t see it here? It can be found by clicking on "View All"'
                    ).show();
                    setTimeout(function () {
                        box.find('[data-task-saved]').fadeOut(750);
                    }, 8000);
                } else {
                    box.find('[data-save-error] [data-content]').text(response.message);
                    box.find('[data-save-error]').show();
                }
        });
    }

    function _loadAndRender(box) {
        _loadTasks(function () {
            _renderTaskTable(box);
        })
    }

    function _remember(key, value) {
        localStorage.setItem('isn-' + ISN.settings.companykey + '-' + ISN.settings.user.id + '-office-task-' + key, value);
    }

    function _recall(key) {
        return localStorage.getItem('isn-' + ISN.settings.companykey + '-' + ISN.settings.user.id + '-office-task-' + key);
    }

    function _addFilter(key, value) {
        _filters[key] = value;
    }

    function _removeFilter(key) {
        if (_filters.hasOwnProperty(key))
            delete _filters[key];
    }

    function _showAddTaskForm(box, bEdit) {
        box.find('[data-edit-view]').show();
        box.find('[data-crud-view]').hide();
        box.find('[data-mode-title]').text((typeof bEdit == 'boolean' && bEdit ? 'Edit' : 'Add') + ' Task');
    }

    function _hideAddTaskForm(box) {
        box.find('[data-edit-view]').hide();
        box.find('[data-crud-view]').show();
        box.find('[data-mode-title]').text('');
    }

    function _renderOrderDetails(details, box) {
        box.find('[data-order-details] > div')
            .empty()
            .append(
                'OID: <strong>' + details.oid + '</strong>',
                ' on <strong>' + details.datetimeformatted + '</strong><br>',
                details.address1 + ('' != details.address2 ? ' ' + details.address2 : '') + '<br>',
                details.city + (details.stateabbreviation != '' ? ' ' + details.stateabbreviation + ', ' : ''),
                details.zip
            )
            .show();
        box.find('[data-order-search]').hide();
        box.find('[data-order-details]').show();
        box.find('[data-no-order-container]').hide();
    }

    function _editTask(id, box) {
        _getTaskDetails(id)
            .then(function (taskDetails) {
                box.find('[data-task-id]').val(id);
                box.find('[data-task-message]').val(taskDetails.message);
                if (!isNaN(taskDetails.oid) && parseInt(taskDetails.oid) > 0) {
                    _loadOrderDetails(taskDetails.oid, box);
                    box.find('[data-order-search]').attr('data-oid', taskDetails.oid);
                } else {
                    box.find('[data-no-order]').prop('checked', true);
                    box.find('[data-order-search]').prop('disabled', true)
                    box.find('[data-order-details]').hide();
                }
                box.find('[data-assigned]').val(taskDetails.assignedToUserId);
                box.find('[data-due]').val(taskDetails.dueDate);
                box.find('[data-due-time]').val(taskDetails.dueTime);
                box.find('[data-remind-email]').prop('checked', taskDetails.remindEmail);
                box.find('[data-remind-sms]').prop('checked', taskDetails.remindSms);
                if (box.find('[data-remind-email]').is(':checked') || box.find('[data-remind-sms]').is(':checked')) {
                    box.find('[data-remind-minutes]').val(taskDetails.remindMinutesBefore);
                    box.find('[data-remind-minutes-container]').show();
                } else {
                    box.find('[data-remind-minutes-container]').hide();
                }
                _showAddTaskForm(box, true);
            });
    }

    function _deleteTask(id) {
        return $.post('/' + ISN.settings.companykey + '/office-task/delete?id=' + id);
    }

    function _resetTaskForm(box) {
        box.find('form [data-order-details]').hide();
        box.find('form [data-order-details] > div').empty();
        box.find('form [data-order-search]').attr('data-oid', '0').prop('disabled', false).val('').show();
        box.find('form [data-no-order-container]').show();
        box.find('form [data-no-order]').prop('checked', false);
        box.find('form [data-remind-email]').prop('checked', false);
        box.find('form [data-remind-sms]').prop('checked', false);
        box.find('form [data-assigned]').val(box.find('[data-assigned] option:first').val());
        box.find('form [data-task-message]').val('');
        box.find('form [data-due]').val('');
        box.find('form [data-due-time]').val(parseInt(ISN.settings.startHour) * 60);
        box.find('form [data-remind-minutes-container]').hide();
        box.find('form [data-remind-minutes]').val(box.find('[data-remind-minutes] option:first').val());
        box.find('form [data-task-id]').val('');
        box.find('[data-save-error]').hide();
    }

    function _disableTaskForm(box) {
        box.find('form textarea').prop('readonly', true);
        box.find('form input[type=checkbox]').prop('disabled', true);
        box.find('form input').prop('readonly', true);
        box.find('form select').prop('disabled', true);
        box.find('form [data-go-back-button]').prop('disabled', true);
        box.find('form [data-save-button]').prop('disabled', true);
    }

    function _enableTaskForm(box) {
        box.find('form textarea').prop('readonly', false);
        box.find('form input[type=checkbox]').prop('disabled', false);
        box.find('form input').prop('readonly', false);
        box.find('form select').prop('disabled', false);
        box.find('form [data-go-back-button]').prop('disabled', false);
        box.find('form [data-save-button]').prop('disabled', false);
    }

    function _filterByTextSearch(term, box) {
        if ('' == term) {
            box.find('tbody > tr').show();
        } else {
            term = term.toLowerCase();
            box.find('tbody > tr').hide();
            box.find('tbody > tr td')
                .contents()
                .filter(function () {
                    return this.textContent.toLowerCase().indexOf(term) != -1;
                })
                .each(function () {
                    $(this).parents('tr').show();
                });
        }
    }

    return {
        /**
         *
         */
        openModal: function () {
            var self = this;
            var options = {
                title: 'Tasks',
                className: 'modal-xl',
                buttons: {
                    cancel: {
                        label: 'Close',
                        className: 'btn-default'
                    }
                }
            };

            var events = {
                open: function (box) {
                    var lastAssignedTo = _recall('filter-assigned-to');
                    if (!lastAssignedTo && ISN.settings.user.username != 'isn') lastAssignedTo = ISN.settings.user.id;

                    if ('' != lastAssignedTo) {
                        _addFilter('assigned', lastAssignedTo);
                    }

                    var lastDue = _recall('filter-due');

                    if ('' != lastDue) {
                        _addFilter('due', lastDue);
                    }

                    _loadTasks(function () {
                        _renderTaskTable(box);
                        if (_totalTaskCount > _tasks.length) {
                            box.find('[data-more]').show();
                        }
                    });

                    box.find('[data-edit-view]').hide();

                    // handling for the user filter
                    box.find('[data-filter-assigned-to]')
                        .on('change', function () {
                            _remember('filter-assigned-to', this.value);
                            if (this.value == 'all') {
                                _removeFilter('assigned');
                            } else {
                                _addFilter('assigned', this.value);
                            }
                            _loadTasks(function () {
                                _renderTaskTable(box);
                                _filterByTextSearch(box.find('[data-search]').val(), box);
                            });
                        })
                        .find('option[value="' + lastAssignedTo + '"]')
                        .prop('selected', true);

                    // handling for the due filter
                    box.find('[data-filter-due]')
                        .on('change', function () {
                            _remember('filter-due', this.value);
                            if (this.value == '') {
                                _removeFilter('due');
                            } else {
                                _addFilter('due', this.value);
                            }
                            _loadTasks(function () {
                                _renderTaskTable(box);
                                _filterByTextSearch(box.find('[data-search]').val(), box);
                            });
                        })
                        .find('option[value="' + lastDue + '"]')
                        .prop('selected', true);

                    // handling for the add task button
                    box.find('[data-add-task-button]')
                        .on('click', function () {
                            _showAddTaskForm(box);
                            box.find('[data-assigned]').val(ISN.settings.user.username != 'isn' ? ISN.settings.user.id : box.find('[data-assigned] option:first').val());
                            box.find('[data-task-message]').focus();
                        });

                    // handling for the go back button
                    box.find('[data-go-back-button]')
                        .on('click', function () {
                            _hideAddTaskForm(box);
                            _resetTaskForm(box);
                        });

                    // handling for the save button
                    box.find('[data-save-button]')
                        .on('click', function () {
                            _saveTask(box);
                        });

                    // handling for order autocomplete
                    box.find('[data-order-search]').typeahead({
                        source: function(query, process) {
                            $.getJSON('/' + ISN.settings.companykey + '/autocomplete/order',
                                {
                                    query: query, limit: 20
                                },
                                process
                            );
                        },
                        displayText: function(item) {
                            return item.label;
                        },
                        afterSelect: function(item) {
                            box.find('[data-order-search]').attr('data-oid', item.id).val('');
                            _loadOrderDetails(item.id, box);
                        }
                    });

                    box.find('[data-order-details]').hide();

                    box.find('[data-dte]').datepicker({
                        autoclose: true,
                        todayBtn: 'linked',
                        todayHighlight: true
                    }).on('hide', function (e) {
                        // hack fix because the datepicker hide event bubbles and kills events attached to modals
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    box.find('[data-no-order]').on('change', function () {
                        if ($(this).is(':checked')) {
                            box.find('[data-order-details]').hide();
                            box.find('[data-order-search]').attr('data-oid', '0').prop('disabled', true);
                        } else {
                            box.find('[data-order-search]').prop('disabled', false);
                        }
                    });

                    box.find('[data-change-order]').on('click', function () {
                        box.find('[data-order-details]').hide();
                        box.find('[data-no-order-container]').show();
                        box.find('[data-order-search]').show().prop('disabled', false).focus();
                    });

                    box.find('[data-remind-email]').on('change', function () {
                        if ($(this).is(':checked') || box.find('[data-remind-sms]').is(':checked')) {
                            box.find('[data-remind-minutes-container]').show();
                        } else {
                            box.find('[data-remind-minutes-container]').hide();
                        }
                    });

                    box.find('[data-remind-sms]').on('change', function () {
                        if ($(this).is(':checked') || box.find('[data-remind-email]').is(':checked')) {
                            box.find('[data-remind-minutes-container]').show();
                        } else {
                            box.find('[data-remind-minutes-container]').hide();
                        }
                    });

                    box.find('[data-search]').on('keyup change', $.debounce(250, function () {
                        _filterByTextSearch(this.value, box);
                    }));
                },
                close: function () {
                    self.updateTasksDueBadge();
                }
            };

            _getModalTemplate(function (template) {
                ISN.show_dialog_from_template(template, options, events);
            });

            return;
        },
        /**
         *
         */
        updateTasksDueBadge: function () {
            $.getJSON('/' + ISN.settings.companykey + '/office-task/recent?incomplete-only=1&assigned=' + ISN.settings.user.id)
                .then(function (response) {
                    var myTasks = response.tasks.filter(function (task) { return task.assignedToUserId == ISN.settings.user.id });
                    var due = 0;
                    var overdue = 0;
                    var total = myTasks.length;
                    for (var i = 0; i < myTasks.length; ++i) {
                        overdue += myTasks[i].overDue ? 1 : 0;
                        due += myTasks[i].dueToday ? 1 : 0;
                    }
                    if (overdue > 0) {
                        $('#tasks-due-badge')
                            .removeClass('label-warning label-default')
                            .addClass('label-danger')
                            .text(overdue)
                            .attr('title', 'There ' + (overdue > 1 ? 'are' : 'is') + ' ' + overdue + ' overdue task' + (overdue > 1 ? 's' : ''))
                            .show();
                    } else if (due > 0) {
                        $('#tasks-due-badge')
                            .removeClass('label-danger label-default')
                            .addClass('label-warning')
                            .text(due)
                            .attr('title', 'There ' + (due > 1 ? 'are' : 'is') + ' ' + due + ' due task' + (due > 1 ? 's' : ''))
                            .show();
                    } else if (total > 0) {
                        $('#tasks-due-badge')
                            .removeClass('label-danger label-warning')
                            .addClass('label-default')
                            .text(total)
                            .attr('title', 'There ' + (total > 1 ? 'are' : 'is') + ' ' + total + ' upcoming task' + (total > 1 ? 's' : ''))
                            .show();
                    } else {
                        $('#tasks-due-badge').hide();
                    }
                });
        }
    };

})(jQuery, Handlebars, ISN);
